export default __webpack_public_path__ + "static/media/linkedin.ac5bfbb0.svg";